<template>
<div class="chapter">
<div class="inner_page">
<p class="C204"><a id="page_xix">ABBREVIATIONS FOR HUME’S WORKS</a></p><a id="page_xix">
<div class="table">
<table>
<tbody><tr class="Row_Style1"><td class="Col_Style1"><em>D</em></td>
<td class="Col_Style2"><em>Dialogues Concerning Natural Religion</em>, ed. Norman Kemp Smith. Indianapolis: Bobbs-Merrill, 1947.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>E</em></td>
<td class="Col_Style2"><em>Essays Moral, Political, and Literary</em>, ed. Eugene Miller. Indianapolis: Liberty Classics, 1985.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>EU/EM</em></td>
<td class="Col_Style2"><em>David Hume’s Enquiries Concerning Human Understanding [EU] and Concerning the Principles of Morals [EM]</em>, ed. L. A. Selby-Bigge. 3d ed. revised, ed. P. H. Nidditch. Oxford: Clarendon Press, 1975.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>H</em></td>
<td class="Col_Style2"><em>The History of England, From the Invasion of Julius Caesar to The Revolution in 1688</em>, with the author’s last corrections and improvements. 6 vols. Indianapolis: Liberty Classics, 1983.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>HEM</em></td>
<td class="Col_Style2">“Hume’s Early Memoranda, 1729–40: The Complete Text,” <em>Journal of the History of Ideas</em> 9 (1948): 492–518.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>L</em></td>
<td class="Col_Style2"><em>The Letters of David Hume</em>, ed. J. Y. T. Greig. 2 vols. Oxford: Clarendon Press, 1969.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>LG</em></td>
<td class="Col_Style2"><em>A Letter from a Gentleman to His Friend in Edinburgh</em>, ed. Ernest C. Mossner and John V. Price. Edinburgh: University of Edinburgh Press, 1967.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>NHL</em></td>
<td class="Col_Style2"><em>New Letters of David Hume</em>, ed. R. Klibansky and E. C. Mossner. Oxford: Clarendon Press, 1954.</td>
</tr>
<tr class="Row_Style2"><td class="Col_Style1"><em>NHR</em></td>
<td class="Col_Style2"><em>The Natural History of Religion and Dialogues Concerning Natural Religion</em>, ed. A. Wayne Colver and John Vladimir Price. Oxford: Clarendon Press, 1976.</td>
</tr>
<tr class="Row_Style3"><td class="Col_Style1"><em>T</em></td>
<td class="Col_Style2"><em>A Treatise of Human Nature</em>, ed. L. A. Selby-Bigge. 2d edition with text revised and variant readings by P. H. Nidditch. Oxford: Clarendon Press, 1978.</td>
</tr>
</tbody></table>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_List_of_Abbreviations.vue?0f384c62